export const isHrefOnlyAnchorTag = (href) => href?.startsWith('#');

export const scrollToAnchorTag = (href, event) => {
	if (isHrefOnlyAnchorTag(href)) {
		event.preventDefault();
		document.querySelector(`#${href.replace('#', '')}`).scrollIntoView({ behavior: 'smooth' });
	}
};
